import { useGtm } from '@gtm-support/vue-gtm'

class InquiriesModule {
  sendInquiryEvent (
    inquiryId: number
  ): void {
    const gtm = useGtm()
    if (!gtm?.enabled()) {
      return
    }
    gtm.trackEvent({
      event: 'anfrage',
      anfrage_id: inquiryId
    })
  }

  sendRecommendationImpressionEvent (
    promotions: []
  ): void {
    const gtm = useGtm()
    if (!gtm?.enabled()) {
      return
    }
    gtm.trackEvent({
      event: 'recommendation_impression',
      ecommerce: {
        promoView: {
          promotions
        }
      }
    })
  }

  sendPromotionClickEvent (
    promotions: []
  ): void {
    const gtm = useGtm()
    if (!gtm?.enabled()) {
      return
    }
    gtm.trackEvent({
      event: 'promotionClick',
      ecommerce: {
        promoClick: {
          promotions
        }
      }
    })
  }
}

export default InquiriesModule
